module.exports = __webpack_public_path__ + "static/media/theMofG20.1e3fada6.png";